import { BaseWidget } from "./BaseWidget";

interface Props {
  value: number;
  compareValue: number;
  loading: boolean;
}

export const NewCustomers = ({ value, compareValue, loading }: Props) => {
  return (
    <BaseWidget
      title="New Customers"
      value={value}
      compareValue={compareValue}
      loading={loading}
      downIsGood={false}
      subtitle="Total new customers"
      valueFormatter={(value) => value.toLocaleString()}
    />
  );
};
